import React from 'react';

export const Heart = () => {
  return (
    <svg viewBox='0 0 512 512'>
      <g>
        <g>
          <path
            d='M469.585,80.732c-55.679-52.984-146.306-52.984-202.003-0.012l-11.581,11l-11.569-10.995
			c-55.703-52.979-146.318-52.973-202.021,0C15.061,106.739,0,141.244,0,177.874c0,36.642,15.061,71.141,42.415,97.166
			l201.219,191.033c3.461,3.294,7.917,4.934,12.366,4.934c4.449,0,8.899-1.647,12.366-4.94l201.219-191.027
			C496.933,249.021,512,214.517,512,177.88C512,141.244,496.933,106.745,469.585,80.732z M444.829,248.991L256,428.269
			L67.177,248.997C47.026,229.835,35.93,204.576,35.93,177.88s11.096-51.955,31.247-71.117
			c21.019-20.001,48.625-29.995,76.237-29.995c27.618,0,55.236,10.006,76.255,30.007l23.953,22.75c6.934,6.593,17.815,6.593,24.75,0
			l23.959-22.762c42.044-39.996,110.448-39.996,152.492,0c20.145,19.163,31.247,44.421,31.247,71.117
			S464.968,229.829,444.829,248.991z'
          />
        </g>
      </g>
    </svg>
  );
};

export const Email = (props) => {
  return (
    <svg style={{ display: 'block' }} width={props.width} viewBox='0 0 512 512'>
      <g>
        <g>
          <path
            fill={props.fill}
            d='M452,68H60C26.916,68,0,94.916,0,128v256c0,33.084,26.916,60,60,60h392c33.084,0,60-26.916,60-60V128
			C512,94.916,485.084,68,452,68z M472,384c0,11.028-8.972,20-20,20H60c-11.028,0-20-8.972-20-20V128c0-11.028,8.972-20,20-20h392
			c11.028,0,20,8.972,20,20V384z'
          />
        </g>
      </g>
      <g>
        <g>
          <polygon
            fill={props.fill}
            points='468.604,92.937 256,251.074 43.396,92.937 19.522,125.032 256,300.926 492.478,125.032 		'
          />
        </g>
      </g>
    </svg>
  );
};
